import { Icon, View } from "@aws-amplify/ui-react";
export default function MicroscopeIcon() {
  return (
    <>
      <Icon
        width="5.28px"
        height="4.1px"
        viewBox={{
          minX: 0,
          minY: 0,
          width: 5.28107213973999,
          height: 4.103075981140137,
        }}
        paths={[
          {
            d: "M0 2.2633L0.964715 0L5.28107 1.83978L4.31636 4.10308L0 2.2633Z",
            fill: "rgba(249,192,192,1)",
            fillRule: "nonzero",
          },
        ]}
        display="block"
        gap="unset"
        alignItems="unset"
        justifyContent="unset"
        position="absolute"
        top="46.01%"
        bottom="48.73%"
        left="54.45%"
        right="38.78%"
      ></Icon>
      <Icon
        width="14.84px"
        height="22.52px"
        viewBox={{
          minX: 0,
          minY: 0,
          width: 14.841400146484375,
          height: 22.517845153808594,
        }}
        paths={[
          {
            d: "M4.64423 22.3694L0.553808 20.6251C0.0891595 20.427 -0.124125 19.8862 0.0739214 19.4292L8.11767 0.553804C8.31572 0.0891556 8.85654 -0.124125 9.31357 0.0739221L14.2876 2.1915C14.7522 2.38955 14.9655 2.93037 14.7675 3.3874L7.10459 21.3792C6.70088 22.3237 5.59638 22.7731 4.64423 22.3694Z",
            fill: "rgba(249,192,192,1)",
            fillRule: "nonzero",
          },
        ]}
        display="block"
        gap="unset"
        alignItems="unset"
        justifyContent="unset"
        position="absolute"
        top="19.84%"
        bottom="51.29%"
        left="55.38%"
        right="25.59%"
      ></Icon>
      <Icon
        width="19.81px"
        height="2.77px"
        viewBox={{
          minX: 0,
          minY: 0,
          width: 19.812305450439453,
          height: 2.772653341293335,
        }}
        paths={[
          {
            d: "M19.0506 2.77265L0.761719 2.77265C0.342773 2.77265 0 2.42988 0 2.01093L0 0.761719C0 0.342773 0.342773 0 0.761719 0L19.0506 0C19.4695 0 19.8123 0.342773 19.8123 0.761719L19.8123 2.01093C19.8123 2.4375 19.4695 2.77265 19.0506 2.77265ZM0.761719 0.61699C0.67793 0.61699 0.609375 0.685545 0.609375 0.769334L0.609375 2.01855C0.609375 2.10234 0.67793 2.1709 0.761719 2.1709L19.0506 2.1709C19.1344 2.1709 19.2029 2.10234 19.2029 2.01855L19.2029 0.769334C19.2029 0.685545 19.1344 0.61699 19.0506 0.61699L0.761719 0.61699Z",
            fill: "rgba(206,2,2,1)",
            fillRule: "nonzero",
          },
        ]}
        display="block"
        gap="unset"
        alignItems="unset"
        justifyContent="unset"
        position="absolute"
        top="64%"
        bottom="32.44%"
        left="45.13%"
        right="29.47%"
      ></Icon>
      <Icon
        width="7.96px"
        height="3.88px"
        viewBox={{
          minX: 0,
          minY: 0,
          width: 7.9586639404296875,
          height: 3.8793582916259766,
        }}
        paths={[
          {
            d: "M0 0.559787L0.24078 0L7.95866 3.31957L7.71788 3.87936L0 0.559787Z",
            fill: "rgba(255,255,255,1)",
            fillRule: "nonzero",
          },
        ]}
        display="block"
        gap="unset"
        alignItems="unset"
        justifyContent="unset"
        position="absolute"
        top="40.2%"
        bottom="54.83%"
        left="55.07%"
        right="34.73%"
      ></Icon>
      <Icon
        width="5.12px"
        height="2.64px"
        viewBox={{
          minX: 0,
          minY: 0,
          width: 5.115854263305664,
          height: 2.639355182647705,
        }}
        paths={[
          {
            d: "M0 0.56055L0.238948 0L5.11585 2.07873L4.87698 2.63936L0 0.56055Z",
            fill: "rgba(153,153,153,1)",
            fillRule: "nonzero",
          },
        ]}
        display="block"
        gap="unset"
        alignItems="unset"
        justifyContent="unset"
        position="absolute"
        top="45.18%"
        bottom="51.44%"
        left="55.01%"
        right="38.43%"
      ></Icon>
      <Icon
        width="41.21px"
        height="58.39px"
        viewBox={{
          minX: 0,
          minY: 0,
          width: 41.208984375,
          height: 58.38514709472656,
        }}
        paths={[
          {
            d: "M34.6201 58.3851L9.81856 58.3851C9.06445 58.3851 8.44746 57.7682 8.44746 57.0141L8.44746 56.7094L11.6619 54.5537C11.8828 54.3328 12.1799 54.2033 12.4922 54.2033L18.9211 54.2033L18.9211 46.548L18.2279 46.548C13.3758 46.5404 8.80547 44.6361 5.35488 41.1779C1.9043 37.7197 0 33.1494 0 28.2973C0 23.4451 1.9043 18.8596 5.3625 15.409C8.8207 11.9584 13.3986 10.0465 18.2508 10.0465L28.3436 10.0465L31.7637 1.81991C32.4035 0.304093 34.1479 -0.404306 35.6561 0.235538L39.3428 1.78944C40.851 2.42929 41.567 4.17362 40.9271 5.68183L33.4242 23.6127C32.9596 24.7096 31.8855 25.418 30.7201 25.4332L29.608 28.0687L23.6285 25.5475L24.7559 22.8662C24.017 22.0207 23.8113 20.8172 24.2531 19.7584L25.091 17.7627L18.9592 17.7627C16.1561 17.7627 13.5129 18.8596 11.5172 20.8629C9.52148 22.8586 8.41699 25.5017 8.41699 28.3049L8.41699 28.3277C8.41699 31.1308 9.51387 33.774 11.5172 35.7697C13.5129 37.7654 16.1561 38.8699 18.9592 38.8699L37.3699 38.8699C39.4494 38.8699 41.209 40.6066 41.209 42.6633L41.209 42.8004C41.209 44.8799 39.518 46.5709 37.4385 46.5709L25.51 46.5709L25.51 54.2262L31.9389 54.2262C32.2512 54.2262 32.5482 54.348 32.7691 54.5766L35.9912 56.7322L35.9912 57.0369C35.9912 57.7758 35.3742 58.3851 34.6201 58.3851ZM9.72715 57.2273C9.75762 57.2426 9.78809 57.2426 9.81856 57.2426L34.6201 57.2426C34.6506 57.2426 34.6811 57.235 34.7115 57.2273L32.015 55.4144L31.9617 55.3535C31.9617 55.3459 31.9541 55.3459 31.9465 55.3459L24.375 55.3459L24.375 45.4055L37.4537 45.4055C38.901 45.4055 40.0816 44.2248 40.0816 42.7775L40.0816 42.6404C40.0816 41.2008 38.8477 39.9896 37.3852 39.9896L18.9744 39.9896C15.8666 39.9896 12.934 38.7709 10.725 36.5619C8.51602 34.3529 7.29727 31.4203 7.29727 28.3125L7.29727 28.2896C7.29727 25.1818 8.51602 22.2492 10.725 20.0402C12.934 17.8312 15.8666 16.6125 18.9744 16.6125L26.8277 16.6125L25.3195 20.1926C25.0072 20.9238 25.2129 21.7693 25.8146 22.2949L26.127 22.5691L25.1291 24.9381L29.0062 26.5682L29.9965 24.2144L30.4307 24.2754C31.2533 24.3896 32.0531 23.9402 32.373 23.1785L39.876 5.24765C40.0664 4.79823 40.0664 4.30312 39.8836 3.84608C39.7008 3.38905 39.3504 3.03866 38.901 2.84823L35.2143 1.29433C34.7648 1.1039 34.2697 1.1039 33.8127 1.28671C33.3557 1.46952 33.0053 1.81991 32.8148 2.26933L29.1053 11.2043L18.266 11.2043C13.7186 11.2043 9.42246 12.9867 6.18516 16.2316C2.94785 19.4766 1.15781 23.765 1.15781 28.3125C1.15781 32.86 2.94023 37.1484 6.17754 40.3857C9.41484 43.623 13.7033 45.4131 18.2508 45.4207L20.0789 45.4207L20.0789 55.3611L12.5074 55.3611C12.4998 55.3611 12.4922 55.3611 12.4846 55.3687L12.4312 55.4297L9.72715 57.2273Z",
            fill: "rgba(153,153,153,1)",
            fillRule: "nonzero",
          },
        ]}
        display="block"
        gap="unset"
        alignItems="unset"
        justifyContent="unset"
        position="absolute"
        top="16.69%"
        bottom="8.46%"
        left="22.39%"
        right="24.78%"
      ></Icon>
      <Icon
        width="7.67px"
        height="9.08px"
        viewBox={{
          minX: 0,
          minY: 0,
          width: 7.668700695037842,
          height: 9.075522422790527,
        }}
        paths={[
          {
            d: "M5.56817 9.07552L0 6.71419L1.54629 3.05794L2.20898 3.33978L3.33633 0.673765C3.57246 0.110093 4.21992 -0.148892 4.78359 0.0872409L6.99258 1.02416C7.2668 1.13841 7.47246 1.35169 7.58672 1.62591C7.70098 1.90013 7.69336 2.1972 7.5791 2.47142L6.45176 5.13744L7.11446 5.41927L5.56817 9.07552ZM0.799805 6.39427L5.24824 8.27572L6.32227 5.73919L5.65957 5.45736L7.03066 2.22767C7.08398 2.1058 7.08398 1.96869 7.03066 1.84681C6.97734 1.72494 6.88594 1.62591 6.76406 1.58021L4.55508 0.643296C4.30371 0.536655 4.01426 0.650913 3.90762 0.909897L2.54414 4.13959L1.88145 3.85775L0.799805 6.39427Z",
            fill: "rgba(153,153,153,1)",
            fillRule: "nonzero",
          },
        ]}
        display="block"
        gap="unset"
        alignItems="unset"
        justifyContent="unset"
        position="absolute"
        top="9.03%"
        bottom="79.34%"
        left="66.73%"
        right="23.44%"
      ></Icon>
      <Icon
        width="3.85px"
        height="2.09px"
        viewBox={{
          minX: 0,
          minY: 0,
          width: 3.845461845397949,
          height: 2.0917558670043945,
        }}
        paths={[
          {
            d: "M0 0.561082L0.237735 0L0.756767 0.219832L0.519112 0.78099L0 0.561082ZM1.46852 1.18546L1.70617 0.62438L3.84546 1.53067L3.60781 2.09176L1.46852 1.18546Z",
            fill: "rgba(153,153,153,1)",
            fillRule: "nonzero",
          },
        ]}
        display="block"
        gap="unset"
        alignItems="unset"
        justifyContent="unset"
        position="absolute"
        top="13.47%"
        bottom="83.85%"
        left="69.62%"
        right="25.45%"
      ></Icon>
      <Icon
        width="18px"
        height="0.64px"
        viewBox={{
          minX: 0,
          minY: 0,
          width: 17.999412536621094,
          height: 0.639845609664917,
        }}
        paths={[
          {
            d: "M0 0L17.9994 0L17.9994 0.639846L0 0.639846L0 0Z",
            fill: "rgba(249,192,192,1)",
            fillRule: "nonzero",
          },
        ]}
        display="block"
        gap="unset"
        alignItems="unset"
        justifyContent="unset"
        position="absolute"
        top="65.63%"
        bottom="33.54%"
        left="46.65%"
        right="30.27%"
      ></Icon>
    </>
  );
}
